import { gql } from 'graphql-tag';

export const LocationInfoFragment = gql`
  fragment LocationInfo on LocationType {
    code
    displayTimezone
    externalLender
    name
    timezone
    referralRequired
  }
`;
